// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"TabImg_TheComp__6oP7u"};